var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('el-empty',{attrs:{"description":"404, 您访问的页面不存在"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.back}},[_vm._v("回到首页")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }